import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';

import { DownloadComponent } from './download.component';

@NgModule({
  declarations: [DownloadComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [DownloadComponent]
})
export class DownloadModule {}
